export default "__VITE_ASSET__BPoLcZ5U__"